

import {
  AiSuggestedQuestion,
  AuditModel
} from '@/libs/Api';
import Page from '@/Page.vue';
import {Guid} from '@/libs/common/functions/guid';
import {Component, Prop, Ref, Watch} from 'vue-property-decorator';
import {auditsStore} from '@/libs/audits/+state/store';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {tenantUsersStore} from '@/libs/tenants/+state/store';
import apiService from '@/libs/core/api-service';

export enum GenerationActionEnum {
  AddToAudit = 'AddToAudit',
  Replace = 'Replace'
}

@Component({})
export default class AiQuestionImprove extends Page {

  dialog = false;
  valid = true;
  saving = false;
  generating = false;
  generateDescription = true;
  generateDisagreementResponse = true;
  messageInput: string | null = null;
  fullMessageInput: string | null = null;
  messageOutput: string | null = null;
  suggestedQuestions: AiSuggestedQuestion[] = [];
  selected: any[] = [];

  get headers() {
    const headers = [
      { text: this.$t('audits.categoryName'), value: "category", align: "left", sortable: false },
      { text: this.$t('audit.questions.code'), value: "code", align: "left", sortable: false },
      { text: this.$t('audit.questions.name'), value: "question", align: "left", sortable: false }
    ];
    if (this.generateDescription) {
      headers.push({ text: this.$t('audit.questions.description'), value: "description", align: "left", sortable: false });
    }
    if (this.generateDisagreementResponse) {
      headers.push({ text: this.$t('audit.questions.disagreementResponse'), value: "disagreementResponse", align: "left", sortable: false });
    }
    return headers;
  }

  get emptyGuid(): string {
    return Guid.EmptyGuid();
  }

  protected GenerationActionEnum = GenerationActionEnum;

  @Watch("dialog")
  dialogChanged(v: boolean): void {
    if (!v)
      this.close();
  }

  @Watch("selected")
  selectedChanged(v: any[]): void {
    console.log(v);
  }

  @Ref() form!: any;
  @Prop() tenantId!: string;
  @Prop() audit!: AuditModel;

  open(): void {
    this.dialog = true;
  }

  close(): void {
    this.dialog = false;
  }

  generate(): void {
    this.generating = true;
    this.suggestedQuestions = [];
    if (this.messageInput != null && this.messageInput.length > 0) {
      apiService.api.improveQuestions(this.audit!.id!, {
        messages: [
          {
            message: this.messageInput
          }
        ],
        generateDescription: this.generateDescription,
        generateDisagreementResponse: this.generateDisagreementResponse
      }).then((e) => {
        this.suggestedQuestions = e.data.returnValue?.suggestedQuestions ?? [];
        this.fullMessageInput = e.data.returnValue && e.data.returnValue!.messages && e.data.returnValue!.messages!.length > 1 ? e.data.returnValue!.messages!.take(e.data.returnValue!.messages!.count() - 1).select(x => x.message).toArray().join("\n\n") : null;
        this.messageOutput = e.data.returnValue?.messages?.lastOrDefault()?.message ?? null;
        this.generating = false;
        this.selected = this.suggestedQuestions;
      }).catch((e) => {
        console.error(e);
        this.generating = false;
        this.selected = [];
      });
    }
  }

  apply() {
    this.$emit(
        "onResult",
        this.generateDescription,
        this.generateDisagreementResponse,
        this.selected
    );
  }

}
